import React from 'react';

export default function DropdownSelector(props) {
  const id = props.id || 'input-' + props.name;
  const label = props.label || props.name;
  const options = props.options || [];
  const value = props.value || '';
  const onChange = function (e) {
    const newValue = e.target.value;
    if (props.onChange) {
      props.onChange({name: props.name, value: newValue});
    } else console.log(props.name, newValue);
  };
  let formGroupClassName = 'form-group';
  if (props.error) formGroupClassName += ' has-error';
  const selectProps = {
    className: 'form-control',
    id,
    name: props.name,
    value: props.value === null ? '' : props.value,
    onChange,
    disabled: props.disabled,
  };
  const isValueOK = options.reduce(option => value === option.value, false);
  const optionTags = (props.placeholder || !isValueOK) ?
  [<option value='' key={'placeholder'} >{props.placeholder}</option>] : []
  options.forEach((option, key) => {
    optionTags.push(
      <option
        value={option.value}
        disabled={option.disabled}
        key={key}
      >
        {option.name}
      </option>
    );
  });
  return (
    <div className={formGroupClassName}>
      { label ? <label htmlFor={id}>{label}</label> : null }
      <select {...selectProps}>

        {optionTags}
      </select>
      <span className="help-block">{props.error || props.message}</span>
    </div>
  );
}



// WEBPACK FOOTER //
// ../hyperdb-utils/src/components/ui-react/DropdownSelector.jsx